export default __webpack_public_path__ + "static/media/about.31cd10b8.jpg";